module.exports = "/images/start-bg@2x.png?144afd1d942f95151046197bcfe127cf";